import type { ImageSeparatorAttributes } from '../../types/cms'
import { StyledImageSeparator } from './styles'

const ImageSeparator = ({ image }: ImageSeparatorAttributes) => {
  const { url, width, height } = image?.data?.attributes ?? {}
  if (!url) return null

  return <StyledImageSeparator url={url} width={width} height={height} />
}

export default ImageSeparator
